const fixPdfName = (pdfString) => {
  return pdfString ? 'data:application/pdf;base64,' + pdfString : '';
};

export default fixPdfName;
